// extracted by mini-css-extract-plugin
export var container = "_5f-0";
export var icon = "_5f-1";
export var text = "_5f-2";